<template>
  <div class="md:flex">
    <div class="inline-block w-256 mr-16">
      <h3 class="text-overline">Type</h3>
      <p class="text-body text-left mb-16">{{ scheduleTypeSentence }}</p>
      <h3 class="text-overline">Start Date</h3>
      <p :class="`text-body text-left ${startDateFlexible ? '' : 'mb-16'}`">{{ formattedStartDate }}</p>
      <p v-if="startDateFlexible" id="start-date-flexible" class="text-body text-left mb-16 italic">Start date is flexible</p>
    </div>
    <div class="inline-block w-256 mb-16">
      <h3 class="text-overline mb-4">Days and Times</h3>
      <div v-if="showWeekdays">
        <p data-test-id="weekdays-header" class="text-body text-left">Weekdays (Monday-Friday):</p>
        <ul class="mb-8">
          <li v-if="nannyDayTimes.includes(NannyHours.WEEKDAY_MORNING)" id="weekdays-morning" class="list-disc ml-28">
            Morning (before school)
          </li>
          <li v-if="nannyDayTimes.includes(NannyHours.WEEKDAY_DAY)" id="weekdays-daytime" class="list-disc ml-28">Daytime</li>
          <li v-if="nannyDayTimes.includes(NannyHours.WEEKDAY_AFTERNOON)" id="weekdays-afternoon" class="list-disc ml-28">
            Afternoon (after school)
          </li>
          <li v-if="nannyDayTimes.includes(NannyHours.WEEKDAY_EVENING)" id="weekdays-evening" class="list-disc ml-28">Evening</li>
        </ul>
      </div>
      <div v-if="showWeekends">
        <p data-test-id="weekends-header" class="text-body text-left">Weekends (Saturday, Sunday):</p>
        <ul class="mb-16">
          <li v-if="nannyDayTimes.includes(NannyHours.WEEKENDS_DAY)" id="weekends-daytime" class="list-disc ml-28">Daytime</li>
          <li v-if="nannyDayTimes.includes(NannyHours.WEEKENDS_EVENING)" id="weekends-evening" class="list-disc ml-28">
            Evening
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { intersection } from 'lodash';
import { EmploymentTypes, NannyHours } from '@/store/modules/job/types';

export default {
  name: 'JobPostScheduleNannyReview',
  props: {
    formattedStartDate: {
      type: String,
      required: true,
    },
    startDateFlexible: {
      type: Boolean,
      required: true,
    },
    nannyScheduleType: {
      type: String as () => EmploymentTypes,
      required: true,
    },
    nannyDayTimes: {
      type: Array as () => NannyHours[],
      required: true,
    },
  },
  computed: {
    NannyHours() {
      // This computed property is used to access the NannyHours enum in the template
      return NannyHours;
    },
    scheduleTypeSentence(): String {
      return this.nannyScheduleType === EmploymentTypes.PART_TIME ? 'Nanny (part-time)' : 'Nanny (full-time)';
    },
    showWeekdays(): boolean {
      const i = intersection(this.nannyDayTimes, [
        NannyHours.WEEKDAY_MORNING,
        NannyHours.WEEKDAY_DAY,
        NannyHours.WEEKDAY_AFTERNOON,
        NannyHours.WEEKDAY_EVENING,
      ]);
      return i.length > 0;
    },
    showWeekends(): boolean {
      const i = intersection(this.nannyDayTimes, [NannyHours.WEEKENDS_DAY, NannyHours.WEEKENDS_EVENING]);
      return i.length > 0;
    },
  },
};
</script>
